import { put, takeLatest, call } from 'redux-saga/effects';
import * as actions from '../ducks/auth';
import { reset } from '../ducks/affiliate';
import { setFlow } from '../ducks/flow';
import { request, finish } from './helpers';
import { setAffToken, clearAffToken } from '../utils/auth';

function* getTerms() {
  const res = yield* request('GET', '/aff/terms', undefined, { silent: true });
  if (res.status === 'success') yield put(actions.setProfile({ terms: res.data.terms }));
}

function* register(action) {
  const res = yield* request('POST', '/aff/register', action.payload);
  yield* finish('register', res, { toastSuccess: false });
}

function* resendOtp(action) {
  const res = yield* request('POST', '/aff/resendOtp', action.payload);
  yield* finish('resendOtp', res);
}

//verify + login both answer with { token, profile }
function* saveSession(res) {
  if (res.status === 'success' && res.data && res.data.token) {
    yield call(setAffToken, res.data.token);
    yield put(actions.setProfile({ profile: res.data.profile }));
  }
}

function* verifyEmail(action) {
  const res = yield* request('POST', '/aff/verifyEmail', action.payload);
  yield* saveSession(res);
  yield* finish('verifyEmail', res, { toastSuccess: false });
}

function* login(action) {
  const res = yield* request('POST', '/aff/login', action.payload);
  if (res.status === 'unverified') {
    //email not verified yet: a new code was sent, the page moves to the verify step
    yield put(setFlow({ name: 'login', ok: false, m: res.m, data: { unverified: true, e: res.data && res.data.e } }));
    return;
  }
  yield* saveSession(res);
  yield* finish('login', res, { toastSuccess: false });
}

function* forgotPassword(action) {
  const res = yield* request('POST', '/aff/forgotPassword', action.payload);
  yield* finish('forgotPassword', res, { toastSuccess: false });
}

function* resetPassword(action) {
  const res = yield* request('POST', '/aff/resetPassword', action.payload);
  yield* finish('resetPassword', res, { toastSuccess: false });
}

function* changePassword(action) {
  const res = yield* request('POST', '/aff/changePassword', action.payload);
  //old tokens stop working after a password change; keep this session with the new one
  if (res.status === 'success' && res.data && res.data.token) yield call(setAffToken, res.data.token);
  yield* finish('changePassword', res);
}

function* getProfile() {
  const res = yield* request('GET', '/aff/profile', undefined, { silent: true });
  if (res.status === 'success') yield put(actions.setProfile({ profile: res.data.profile, terms: res.data.terms }));
}

function* updateProfile(action) {
  const res = yield* request('POST', '/aff/profile', action.payload);
  if (res.status === 'success') yield put(actions.setProfile({ profile: res.data.profile }));
  yield* finish('updateProfile', res);
}

function* logout() {
  yield call(clearAffToken);
  yield put(actions.clearProfile());
  yield put(reset());
}

export default function* authSaga() {
  yield takeLatest(actions.getTerms.type, getTerms);
  yield takeLatest(actions.register.type, register);
  yield takeLatest(actions.resendOtp.type, resendOtp);
  yield takeLatest(actions.verifyEmail.type, verifyEmail);
  yield takeLatest(actions.login.type, login);
  yield takeLatest(actions.forgotPassword.type, forgotPassword);
  yield takeLatest(actions.resetPassword.type, resetPassword);
  yield takeLatest(actions.changePassword.type, changePassword);
  yield takeLatest(actions.getProfile.type, getProfile);
  yield takeLatest(actions.updateProfile.type, updateProfile);
  yield takeLatest(actions.logout.type, logout);
}
